export default "__VITE_ASSET__D0bqyC3n__"